import { useState, useEffect } from "react"

import ErrorMessage from "components/forms/error-message"
import lodash from "lodash"
import deepdash from "deepdash"
import { lang } from "config"
import Label from "components/forms/label"
import Input from "components/forms/input"
import Description from "components/forms/description"
import nProgress from "nprogress"
import toast from "react-hot-toast"
import Checkbox from "components/forms/checkbox"

export default function Form({ data, errors, onSubmit }) {
    const _ = deepdash(lodash)

    const id = data?.id

    const [name, setName] = useState(data?.name ?? null)
    const [isVisible, setisVisible] = useState(data?.is_visible ?? true)

    const handleSubmit = (e) => {
        e.preventDefault()

        if (!nProgress.isStarted()) {
            onSubmit({
                id,
                name,
                isVisible
            })
        } else {
            toast.error("Aksi sebelumnya sedang berjalan")
        }
    }
    return (
        <form onSubmit={handleSubmit} className="mt-8 space-y-8">
            <div className="mt-10 sm:mt-0">
                <div className="md:grid md:grid-cols-3 md:gap-6">
                    <div className="md:col-span-1">
                        <div className="px-4 sm:px-0">
                            <h3 className="text-lg font-medium leading-6 text-gray-900">{lang.main_form}</h3>
                            <p className="mt-1 text-sm text-gray-600">{lang.please_fill_the_provided_form_input}</p>
                        </div>
                    </div>
                    <div className="mt-5 md:col-span-2 md:mt-0">
                        <div className="border sm:rounded-xl">
                            <div className="px-4 py-5 sm:p-6">
                                <div className="grid grid-cols-1 gap-4">
                                    <div>
                                        <Label htmlFor="name" value={lang.name} />
                                        <Input placeholder="Color" onChange={(e) => setName(e.target.value)} value={name} id="name" error={errors.name} />
                                        <Description error={errors.name} />
                                    </div>
                                    
                                    <div className="flex items-start">
                                        <div className="flex items-center h-5">
                                            <Checkbox id="is_visible" checked={isVisible} onChange={() => setisVisible(!isVisible)} />
                                        </div>
                                        <div className="ml-3 text-sm">
                                            <label htmlFor="is_visible" className="font-medium text-gray-700">
                                                Tampilkan
                                            </label>
                                            <p className="text-gray-500">Hilangkan centang jika atribut tidak ingin ditampilkan.</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div className="mt-8 text-xs text-right">
                <button type="submit" className="items-center px-6 py-3 text-white transition bg-brand-800 rounded-xl active:hover:scale-90">
                    <span>{`${_.isEmpty(data) ? lang.create : lang.update}`}</span>
                </button>
            </div>
        </form>
    )
}